export const ZZZDeadlyDuos = [
  {
    char: 'miyabi',
    app: 90.09,
    char_1: 'yanagi',
    app_rate_1: 30.22,
    avg_round_1: 26914,
    app_flat_1: 0,
    char_2: 'soukaku',
    app_rate_2: 30.03,
    avg_round_2: 24496,
    app_flat_2: 0,
    char_3: 'burnice',
    app_rate_3: 26.11,
    avg_round_3: 29348,
    app_flat_3: 0,
    char_4: 'lucy',
    app_rate_4: 24.91,
    avg_round_4: 28002,
    app_flat_4: 0,
    char_5: 'astra-yao',
    app_rate_5: 19.35,
    avg_round_5: 32989,
    app_flat_5: 0,
    char_6: 'lycaon',
    app_rate_6: 18.52,
    avg_round_6: 24618,
    app_flat_6: 0,
    char_7: 'rina',
    app_rate_7: 11.8,
    avg_round_7: 25565,
    app_flat_7: 0,
    char_8: 'nicole-demara',
    app_rate_8: 9.58,
    avg_round_8: 29029,
    app_flat_8: 0,
    char_9: 'caesar',
    app_rate_9: 6.92,
    avg_round_9: 22591,
    app_flat_9: 0,
    char_10: 'vivian',
    app_rate_10: 4.93,
    avg_round_10: 32788,
    app_flat_10: 0,
    char_11: 'lighter',
    app_rate_11: 3.13,
    avg_round_11: 24578,
    app_flat_11: 0,
    char_12: 'trigger',
    app_rate_12: 2.18,
    avg_round_12: 26585,
    app_flat_12: 0,
    char_13: 'piper',
    app_rate_13: 1.94,
    avg_round_13: 22811,
    app_flat_13: 0,
    char_14: 'grace-howard',
    app_rate_14: 1.5,
    avg_round_14: 21584,
    app_flat_14: 0,
    char_15: 'harumasa',
    app_rate_15: 0.87,
    avg_round_15: 22708,
    app_flat_15: 0,
    char_16: 'seth',
    app_rate_16: 0.76,
    avg_round_16: 19029,
    app_flat_16: 0,
    char_17: 'ellen',
    app_rate_17: 0.65,
    avg_round_17: 19597,
    app_flat_17: 0,
    char_18: 'qingyi',
    app_rate_18: 0.49,
    avg_round_18: 18213,
    app_flat_18: 0,
    char_19: 'jane-doe',
    app_rate_19: 0.47,
    avg_round_19: 24688,
    app_flat_19: 0,
    char_20: 'evelyn',
    app_rate_20: 0.47,
    avg_round_20: 26044,
    app_flat_20: 0,
    char_21: 'pulchra',
    app_rate_21: 0.38,
    avg_round_21: 15428,
    app_flat_21: 0,
    char_22: 'koleda',
    app_rate_22: 0.34,
    avg_round_22: 19162,
    app_flat_22: 0,
    char_23: 'zhu-yuan',
    app_rate_23: 0.34,
    avg_round_23: 21452,
    app_flat_23: 0,
    char_24: 'anby-demara',
    app_rate_24: 0.15,
    avg_round_24: 30809,
    app_flat_24: 0,
    char_25: 'anby-demara-soldier-0',
    app_rate_25: 0.08,
    avg_round_25: 13952,
    app_flat_25: 0,
    char_26: 'soldier-11',
    app_rate_26: 0.04,
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'nekomata',
    app_rate_27: 0.04,
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'astra-yao',
    app: 78.23,
    char_1: 'evelyn',
    app_rate_1: 24.1,
    avg_round_1: 30606,
    app_flat_1: 0,
    char_2: 'miyabi',
    app_rate_2: 22.29,
    avg_round_2: 32989,
    app_flat_2: 0,
    char_3: 'anby-demara-soldier-0',
    app_rate_3: 17.5,
    avg_round_3: 31344,
    app_flat_3: 0,
    char_4: 'trigger',
    app_rate_4: 17.37,
    avg_round_4: 32954,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 14.33,
    avg_round_5: 31918,
    app_flat_5: 0,
    char_6: 'yanagi',
    app_rate_6: 14.18,
    avg_round_6: 35236,
    app_flat_6: 0,
    char_7: 'vivian',
    app_rate_7: 11.62,
    avg_round_7: 39716,
    app_flat_7: 0,
    char_8: 'zhu-yuan',
    app_rate_8: 9.31,
    avg_round_8: 29326,
    app_flat_8: 0,
    char_9: 'qingyi',
    app_rate_9: 8.78,
    avg_round_9: 26576,
    app_flat_9: 0,
    char_10: 'burnice',
    app_rate_10: 7.6,
    avg_round_10: 32434,
    app_flat_10: 0,
    char_11: 'lighter',
    app_rate_11: 7.17,
    avg_round_11: 34054,
    app_flat_11: 0,
    char_12: 'ellen',
    app_rate_12: 6.93,
    avg_round_12: 23903,
    app_flat_12: 0,
    char_13: 'jane-doe',
    app_rate_13: 6.88,
    avg_round_13: 35374,
    app_flat_13: 0,
    char_14: 'koleda',
    app_rate_14: 6.38,
    avg_round_14: 27423,
    app_flat_14: 0,
    char_15: 'lycaon',
    app_rate_15: 6.31,
    avg_round_15: 25315,
    app_flat_15: 0,
    char_16: 'harumasa',
    app_rate_16: 5.37,
    avg_round_16: 25121,
    app_flat_16: 0,
    char_17: 'caesar',
    app_rate_17: 3.63,
    avg_round_17: 28759,
    app_flat_17: 0,
    char_18: 'pulchra',
    app_rate_18: 2.71,
    avg_round_18: 24561,
    app_flat_18: 0,
    char_19: 'soukaku',
    app_rate_19: 2.29,
    avg_round_19: 25288,
    app_flat_19: 0,
    char_20: 'lucy',
    app_rate_20: 1.66,
    avg_round_20: 27600,
    app_flat_20: 0,
    char_21: 'piper',
    app_rate_21: 1.33,
    avg_round_21: 28634,
    app_flat_21: 0,
    char_22: 'soldier-11',
    app_rate_22: 1.16,
    avg_round_22: 24593,
    app_flat_22: 0,
    char_23: 'rina',
    app_rate_23: 1.14,
    avg_round_23: 26064,
    app_flat_23: 0,
    char_24: 'anby-demara',
    app_rate_24: 0.96,
    avg_round_24: 19372,
    app_flat_24: 0,
    char_25: 'grace-howard',
    app_rate_25: 0.85,
    avg_round_25: 27684,
    app_flat_25: 0,
    char_26: 'seth',
    app_rate_26: 0.72,
    avg_round_26: 20302,
    app_flat_26: 0,
    char_27: 'nekomata',
    app_rate_27: 0.63,
    avg_round_27: 26422,
    app_flat_27: 0,
    char_28: 'anton',
    app_rate_28: 0.28,
    avg_round_28: 26906,
    app_flat_28: 0,
    char_29: 'corin',
    app_rate_29: 0.15,
    avg_round_29: 30224,
    app_flat_29: 0,
    char_30: 'billy-kid',
    app_rate_30: 0.13,
    avg_round_30: 30590,
    app_flat_30: 0
  },
  {
    char: 'nicole-demara',
    app: 57.32,
    char_1: 'zhu-yuan',
    app_rate_1: 51.07,
    avg_round_1: 26037,
    app_flat_1: 0,
    char_2: 'qingyi',
    app_rate_2: 39.68,
    avg_round_2: 25576,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 19.56,
    avg_round_3: 31918,
    app_flat_3: 0,
    char_4: 'miyabi',
    app_rate_4: 15.06,
    avg_round_4: 29029,
    app_flat_4: 0,
    char_5: 'trigger',
    app_rate_5: 10.55,
    avg_round_5: 28589,
    app_flat_5: 0,
    char_6: 'anby-demara-soldier-0',
    app_rate_6: 10.02,
    avg_round_6: 26917,
    app_flat_6: 0,
    char_7: 'harumasa',
    app_rate_7: 7.04,
    avg_round_7: 22591,
    app_flat_7: 0,
    char_8: 'vivian',
    app_rate_8: 6.32,
    avg_round_8: 28371,
    app_flat_8: 0,
    char_9: 'evelyn',
    app_rate_9: 5.4,
    avg_round_9: 30378,
    app_flat_9: 0,
    char_10: 'yanagi',
    app_rate_10: 5.16,
    avg_round_10: 28114,
    app_flat_10: 0,
    char_11: 'anby-demara',
    app_rate_11: 4.95,
    avg_round_11: 18860,
    app_flat_11: 0,
    char_12: 'caesar',
    app_rate_12: 3.85,
    avg_round_12: 26469,
    app_flat_12: 0,
    char_13: 'jane-doe',
    app_rate_13: 3.04,
    avg_round_13: 24479,
    app_flat_13: 0,
    char_14: 'burnice',
    app_rate_14: 2.86,
    avg_round_14: 26679,
    app_flat_14: 0,
    char_15: 'lycaon',
    app_rate_15: 2.65,
    avg_round_15: 20458,
    app_flat_15: 0,
    char_16: 'ellen',
    app_rate_16: 2.24,
    avg_round_16: 20122,
    app_flat_16: 0,
    char_17: 'soukaku',
    app_rate_17: 2.09,
    avg_round_17: 22020,
    app_flat_17: 0,
    char_18: 'lucy',
    app_rate_18: 1.4,
    avg_round_18: 21968,
    app_flat_18: 0,
    char_19: 'nekomata',
    app_rate_19: 1.28,
    avg_round_19: 23660,
    app_flat_19: 0,
    char_20: 'pulchra',
    app_rate_20: 1.25,
    avg_round_20: 20390,
    app_flat_20: 0,
    char_21: 'rina',
    app_rate_21: 0.83,
    avg_round_21: 21349,
    app_flat_21: 0,
    char_22: 'koleda',
    app_rate_22: 0.75,
    avg_round_22: 24528,
    app_flat_22: 0,
    char_23: 'piper',
    app_rate_23: 0.69,
    avg_round_23: 26416,
    app_flat_23: 0,
    char_24: 'seth',
    app_rate_24: 0.54,
    avg_round_24: 16129,
    app_flat_24: 0,
    char_25: 'lighter',
    app_rate_25: 0.48,
    avg_round_25: 19588,
    app_flat_25: 0,
    char_26: 'billy-kid',
    app_rate_26: 0.42,
    avg_round_26: 25395,
    app_flat_26: 0,
    char_27: 'anton',
    app_rate_27: 0.36,
    avg_round_27: 27898,
    app_flat_27: 0,
    char_28: 'soldier-11',
    app_rate_28: 0.33,
    avg_round_28: 18845,
    app_flat_28: 0,
    char_29: 'corin',
    app_rate_29: 0.3,
    avg_round_29: 26580,
    app_flat_29: 0,
    char_30: 'grace-howard',
    app_rate_30: 0.27,
    avg_round_30: 18611,
    app_flat_30: 0
  },
  {
    char: 'yanagi',
    app: 46.92,
    char_1: 'miyabi',
    app_rate_1: 58.03,
    avg_round_1: 26914,
    app_flat_1: 0,
    char_2: 'rina',
    app_rate_2: 31.04,
    avg_round_2: 26132,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 23.64,
    avg_round_3: 35236,
    app_flat_3: 0,
    char_4: 'burnice',
    app_rate_4: 16.79,
    avg_round_4: 26771,
    app_flat_4: 0,
    char_5: 'caesar',
    app_rate_5: 12.97,
    avg_round_5: 24232,
    app_flat_5: 0,
    char_6: 'vivian',
    app_rate_6: 12.46,
    avg_round_6: 36574,
    app_flat_6: 0,
    char_7: 'trigger',
    app_rate_7: 10.46,
    avg_round_7: 27278,
    app_flat_7: 0,
    char_8: 'soukaku',
    app_rate_8: 8.23,
    avg_round_8: 23560,
    app_flat_8: 0,
    char_9: 'lucy',
    app_rate_9: 7.69,
    avg_round_9: 25496,
    app_flat_9: 0,
    char_10: 'nicole-demara',
    app_rate_10: 6.3,
    avg_round_10: 28114,
    app_flat_10: 0,
    char_11: 'seth',
    app_rate_11: 4.23,
    avg_round_11: 21041,
    app_flat_11: 0,
    char_12: 'harumasa',
    app_rate_12: 1.71,
    avg_round_12: 19756,
    app_flat_12: 0,
    char_13: 'qingyi',
    app_rate_13: 1.57,
    avg_round_13: 18284,
    app_flat_13: 0,
    char_14: 'anby-demara-soldier-0',
    app_rate_14: 1.49,
    avg_round_14: 18176,
    app_flat_14: 0,
    char_15: 'lycaon',
    app_rate_15: 0.98,
    avg_round_15: 23783,
    app_flat_15: 0,
    char_16: 'jane-doe',
    app_rate_16: 0.8,
    avg_round_16: 24369,
    app_flat_16: 0,
    char_17: 'piper',
    app_rate_17: 0.47,
    avg_round_17: 20024,
    app_flat_17: 0,
    char_18: 'grace-howard',
    app_rate_18: 0.44,
    avg_round_18: 17152,
    app_flat_18: 0,
    char_19: 'anby-demara',
    app_rate_19: 0.44,
    avg_round_19: 18098,
    app_flat_19: 0,
    char_20: 'evelyn',
    app_rate_20: 0.4,
    avg_round_20: 15867,
    app_flat_20: 0,
    char_21: 'ellen',
    app_rate_21: 0.18,
    avg_round_21: 13649,
    app_flat_21: 0,
    char_22: 'zhu-yuan',
    app_rate_22: 0.15,
    avg_round_22: 12600,
    app_flat_22: 0,
    char_23: 'pulchra',
    app_rate_23: 0.15,
    avg_round_23: 20968,
    app_flat_23: 0,
    char_24: 'lighter',
    app_rate_24: 0.15,
    avg_round_24: 17436,
    app_flat_24: 0,
    char_25: 'soldier-11',
    app_rate_25: 0.04,
    avg_round_25: 18334,
    app_flat_25: 0,
    char_26: 'koleda',
    app_rate_26: 0.04,
    avg_round_26: 16574,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trigger',
    app: 45.22,
    char_1: 'anby-demara-soldier-0',
    app_rate_1: 61.38,
    avg_round_1: 28738,
    app_flat_1: 0,
    char_2: 'astra-yao',
    app_rate_2: 30.05,
    avg_round_2: 32954,
    app_flat_2: 0,
    char_3: 'caesar',
    app_rate_3: 14.89,
    avg_round_3: 27328,
    app_flat_3: 0,
    char_4: 'rina',
    app_rate_4: 14.74,
    avg_round_4: 24281,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 13.38,
    avg_round_5: 28589,
    app_flat_5: 0,
    char_6: 'yanagi',
    app_rate_6: 10.85,
    avg_round_6: 27278,
    app_flat_6: 0,
    char_7: 'harumasa',
    app_rate_7: 9.41,
    avg_round_7: 23065,
    app_flat_7: 0,
    char_8: 'pulchra',
    app_rate_8: 6.92,
    avg_round_8: 22953,
    app_flat_8: 0,
    char_9: 'evelyn',
    app_rate_9: 6.12,
    avg_round_9: 31274,
    app_flat_9: 0,
    char_10: 'qingyi',
    app_rate_10: 4.88,
    avg_round_10: 20768,
    app_flat_10: 0,
    char_11: 'lucy',
    app_rate_11: 4.61,
    avg_round_11: 26668,
    app_flat_11: 0,
    char_12: 'miyabi',
    app_rate_12: 4.35,
    avg_round_12: 26585,
    app_flat_12: 0,
    char_13: 'zhu-yuan',
    app_rate_13: 4.23,
    avg_round_13: 26312,
    app_flat_13: 0,
    char_14: 'ellen',
    app_rate_14: 2.61,
    avg_round_14: 21678,
    app_flat_14: 0,
    char_15: 'soukaku',
    app_rate_15: 1.89,
    avg_round_15: 21969,
    app_flat_15: 0,
    char_16: 'burnice',
    app_rate_16: 1.59,
    avg_round_16: 27362,
    app_flat_16: 0,
    char_17: 'vivian',
    app_rate_17: 1.25,
    avg_round_17: 28299,
    app_flat_17: 0,
    char_18: 'soldier-11',
    app_rate_18: 1.17,
    avg_round_18: 21628,
    app_flat_18: 0,
    char_19: 'jane-doe',
    app_rate_19: 1.06,
    avg_round_19: 22107,
    app_flat_19: 0,
    char_20: 'lycaon',
    app_rate_20: 0.91,
    avg_round_20: 20641,
    app_flat_20: 0,
    char_21: 'grace-howard',
    app_rate_21: 0.83,
    avg_round_21: 16008,
    app_flat_21: 0,
    char_22: 'seth',
    app_rate_22: 0.76,
    avg_round_22: 16714,
    app_flat_22: 0,
    char_23: 'lighter',
    app_rate_23: 0.49,
    avg_round_23: 27769,
    app_flat_23: 0,
    char_24: 'anby-demara',
    app_rate_24: 0.49,
    avg_round_24: 16032,
    app_flat_24: 0,
    char_25: 'nekomata',
    app_rate_25: 0.42,
    avg_round_25: 23593,
    app_flat_25: 0,
    char_26: 'corin',
    app_rate_26: 0.34,
    avg_round_26: 22870,
    app_flat_26: 0,
    char_27: 'billy-kid',
    app_rate_27: 0.26,
    avg_round_27: 23054,
    app_flat_27: 0,
    char_28: 'koleda',
    app_rate_28: 0.23,
    avg_round_28: 23550,
    app_flat_28: 0,
    char_29: 'anton',
    app_rate_29: 0.19,
    avg_round_29: 20327,
    app_flat_29: 0,
    char_30: 'piper',
    app_rate_30: 0.08,
    avg_round_30: 39087,
    app_flat_30: 0
  },
  {
    char: 'burnice',
    app: 42.85,
    char_1: 'miyabi',
    app_rate_1: 54.89,
    avg_round_1: 29348,
    app_flat_1: 0,
    char_2: 'lucy',
    app_rate_2: 46.87,
    avg_round_2: 27902,
    app_flat_2: 0,
    char_3: 'yanagi',
    app_rate_3: 18.39,
    avg_round_3: 26771,
    app_flat_3: 0,
    char_4: 'jane-doe',
    app_rate_4: 17.07,
    avg_round_4: 23942,
    app_flat_4: 0,
    char_5: 'astra-yao',
    app_rate_5: 13.88,
    avg_round_5: 32434,
    app_flat_5: 0,
    char_6: 'caesar',
    app_rate_6: 10.57,
    avg_round_6: 24283,
    app_flat_6: 0,
    char_7: 'vivian',
    app_rate_7: 6.74,
    avg_round_7: 27510,
    app_flat_7: 0,
    char_8: 'soukaku',
    app_rate_8: 6.02,
    avg_round_8: 25806,
    app_flat_8: 0,
    char_9: 'piper',
    app_rate_9: 5.82,
    avg_round_9: 22725,
    app_flat_9: 0,
    char_10: 'rina',
    app_rate_10: 5.07,
    avg_round_10: 26733,
    app_flat_10: 0,
    char_11: 'nicole-demara',
    app_rate_11: 3.83,
    avg_round_11: 26679,
    app_flat_11: 0,
    char_12: 'seth',
    app_rate_12: 2.11,
    avg_round_12: 18753,
    app_flat_12: 0,
    char_13: 'trigger',
    app_rate_13: 1.68,
    avg_round_13: 27362,
    app_flat_13: 0,
    char_14: 'evelyn',
    app_rate_14: 1.6,
    avg_round_14: 20160,
    app_flat_14: 0,
    char_15: 'lighter',
    app_rate_15: 1.36,
    avg_round_15: 22911,
    app_flat_15: 0,
    char_16: 'grace-howard',
    app_rate_16: 0.84,
    avg_round_16: 18034,
    app_flat_16: 0,
    char_17: 'soldier-11',
    app_rate_17: 0.8,
    avg_round_17: 19462,
    app_flat_17: 0,
    char_18: 'lycaon',
    app_rate_18: 0.6,
    avg_round_18: 20561,
    app_flat_18: 0,
    char_19: 'pulchra',
    app_rate_19: 0.48,
    avg_round_19: 20929,
    app_flat_19: 0,
    char_20: 'koleda',
    app_rate_20: 0.36,
    avg_round_20: 15229,
    app_flat_20: 0,
    char_21: 'ellen',
    app_rate_21: 0.36,
    avg_round_21: 13770,
    app_flat_21: 0,
    char_22: 'harumasa',
    app_rate_22: 0.32,
    avg_round_22: 14510,
    app_flat_22: 0,
    char_23: 'anby-demara-soldier-0',
    app_rate_23: 0.24,
    avg_round_23: 18557,
    app_flat_23: 0,
    char_24: 'qingyi',
    app_rate_24: 0.24,
    avg_round_24: 18704,
    app_flat_24: 0,
    char_25: 'ben',
    app_rate_25: 0.12,
    avg_round_25: 15606,
    app_flat_25: 0,
    char_26: 'nekomata',
    app_rate_26: 0.12,
    avg_round_26: 21222,
    app_flat_26: 0,
    char_27: 'zhu-yuan',
    app_rate_27: 0.12,
    avg_round_27: 10311,
    app_flat_27: 0,
    char_28: 'anby-demara',
    app_rate_28: 0.08,
    avg_round_28: 9352,
    app_flat_28: 0,
    char_29: 'corin',
    app_rate_29: 0.04,
    avg_round_29: 20394,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'soukaku',
    app: 40.76,
    char_1: 'miyabi',
    app_rate_1: 66.37,
    avg_round_1: 24496,
    app_flat_1: 0,
    char_2: 'lycaon',
    app_rate_2: 54.0,
    avg_round_2: 22603,
    app_flat_2: 0,
    char_3: 'ellen',
    app_rate_3: 31.91,
    avg_round_3: 19644,
    app_flat_3: 0,
    char_4: 'yanagi',
    app_rate_4: 9.48,
    avg_round_4: 23560,
    app_flat_4: 0,
    char_5: 'burnice',
    app_rate_5: 6.33,
    avg_round_5: 25806,
    app_flat_5: 0,
    char_6: 'caesar',
    app_rate_6: 5.66,
    avg_round_6: 20842,
    app_flat_6: 0,
    char_7: 'astra-yao',
    app_rate_7: 4.4,
    avg_round_7: 25288,
    app_flat_7: 0,
    char_8: 'nicole-demara',
    app_rate_8: 2.94,
    avg_round_8: 22020,
    app_flat_8: 0,
    char_9: 'lighter',
    app_rate_9: 2.89,
    avg_round_9: 20620,
    app_flat_9: 0,
    char_10: 'vivian',
    app_rate_10: 2.1,
    avg_round_10: 27840,
    app_flat_10: 0,
    char_11: 'trigger',
    app_rate_11: 2.1,
    avg_round_11: 21969,
    app_flat_11: 0,
    char_12: 'lucy',
    app_rate_12: 1.8,
    avg_round_12: 21699,
    app_flat_12: 0,
    char_13: 'qingyi',
    app_rate_13: 1.43,
    avg_round_13: 19648,
    app_flat_13: 0,
    char_14: 'rina',
    app_rate_14: 1.38,
    avg_round_14: 17983,
    app_flat_14: 0,
    char_15: 'grace-howard',
    app_rate_15: 0.59,
    avg_round_15: 21586,
    app_flat_15: 0,
    char_16: 'harumasa',
    app_rate_16: 0.55,
    avg_round_16: 18774,
    app_flat_16: 0,
    char_17: 'jane-doe',
    app_rate_17: 0.46,
    avg_round_17: 18629,
    app_flat_17: 0,
    char_18: 'pulchra',
    app_rate_18: 0.42,
    avg_round_18: 14046,
    app_flat_18: 0,
    char_19: 'piper',
    app_rate_19: 0.38,
    avg_round_19: 19421,
    app_flat_19: 0,
    char_20: 'anby-demara',
    app_rate_20: 0.34,
    avg_round_20: 16818,
    app_flat_20: 0,
    char_21: 'koleda',
    app_rate_21: 0.29,
    avg_round_21: 17648,
    app_flat_21: 0,
    char_22: 'evelyn',
    app_rate_22: 0.25,
    avg_round_22: 21228,
    app_flat_22: 0,
    char_23: 'seth',
    app_rate_23: 0.25,
    avg_round_23: 13123,
    app_flat_23: 0,
    char_24: 'zhu-yuan',
    app_rate_24: 0.17,
    avg_round_24: 20659,
    app_flat_24: 0,
    char_25: 'anby-demara-soldier-0',
    app_rate_25: 0.13,
    avg_round_25: 14266,
    app_flat_25: 0,
    char_26: 'corin',
    app_rate_26: 0.08,
    avg_round_26: 40261,
    app_flat_26: 0,
    char_27: 'soldier-11',
    app_rate_27: 0.04,
    avg_round_27: 12237,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'qingyi',
    app: 40.06,
    char_1: 'zhu-yuan',
    app_rate_1: 58.15,
    avg_round_1: 25519,
    app_flat_1: 0,
    char_2: 'nicole-demara',
    app_rate_2: 56.78,
    avg_round_2: 25576,
    app_flat_2: 0,
    char_3: 'harumasa',
    app_rate_3: 25.17,
    avg_round_3: 23856,
    app_flat_3: 0,
    char_4: 'astra-yao',
    app_rate_4: 17.15,
    avg_round_4: 26576,
    app_flat_4: 0,
    char_5: 'rina',
    app_rate_5: 11.35,
    avg_round_5: 22103,
    app_flat_5: 0,
    char_6: 'anby-demara-soldier-0',
    app_rate_6: 6.95,
    avg_round_6: 21162,
    app_flat_6: 0,
    char_7: 'trigger',
    app_rate_7: 5.5,
    avg_round_7: 20768,
    app_flat_7: 0,
    char_8: 'caesar',
    app_rate_8: 3.5,
    avg_round_8: 22222,
    app_flat_8: 0,
    char_9: 'evelyn',
    app_rate_9: 3.2,
    avg_round_9: 27101,
    app_flat_9: 0,
    char_10: 'lucy',
    app_rate_10: 1.83,
    avg_round_10: 19421,
    app_flat_10: 0,
    char_11: 'yanagi',
    app_rate_11: 1.83,
    avg_round_11: 18284,
    app_flat_11: 0,
    char_12: 'ellen',
    app_rate_12: 1.66,
    avg_round_12: 19172,
    app_flat_12: 0,
    char_13: 'soukaku',
    app_rate_13: 1.45,
    avg_round_13: 19648,
    app_flat_13: 0,
    char_14: 'miyabi',
    app_rate_14: 1.11,
    avg_round_14: 18213,
    app_flat_14: 0,
    char_15: 'jane-doe',
    app_rate_15: 0.81,
    avg_round_15: 16820,
    app_flat_15: 0,
    char_16: 'pulchra',
    app_rate_16: 0.68,
    avg_round_16: 15435,
    app_flat_16: 0,
    char_17: 'corin',
    app_rate_17: 0.55,
    avg_round_17: 23352,
    app_flat_17: 0,
    char_18: 'nekomata',
    app_rate_18: 0.47,
    avg_round_18: 24302,
    app_flat_18: 0,
    char_19: 'anton',
    app_rate_19: 0.34,
    avg_round_19: 23706,
    app_flat_19: 0,
    char_20: 'vivian',
    app_rate_20: 0.3,
    avg_round_20: 13164,
    app_flat_20: 0,
    char_21: 'burnice',
    app_rate_21: 0.26,
    avg_round_21: 18704,
    app_flat_21: 0,
    char_22: 'anby-demara',
    app_rate_22: 0.26,
    avg_round_22: 10859,
    app_flat_22: 0,
    char_23: 'seth',
    app_rate_23: 0.26,
    avg_round_23: 15060,
    app_flat_23: 0,
    char_24: 'grace-howard',
    app_rate_24: 0.21,
    avg_round_24: 17358,
    app_flat_24: 0,
    char_25: 'soldier-11',
    app_rate_25: 0.17,
    avg_round_25: 16536,
    app_flat_25: 0,
    char_26: 'lycaon',
    app_rate_26: 0.13,
    avg_round_26: 17744,
    app_flat_26: 0,
    char_27: 'lighter',
    app_rate_27: 0.09,
    avg_round_27: 6234,
    app_flat_27: 0,
    char_28: 'billy-kid',
    app_rate_28: 0.04,
    avg_round_28: 31046,
    app_flat_28: 0,
    char_29: 'koleda',
    app_rate_29: 0.04,
    avg_round_29: 12776,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lucy',
    app: 39.82,
    char_1: 'miyabi',
    app_rate_1: 56.35,
    avg_round_1: 28002,
    app_flat_1: 0,
    char_2: 'burnice',
    app_rate_2: 50.43,
    avg_round_2: 27902,
    app_flat_2: 0,
    char_3: 'lighter',
    app_rate_3: 10.21,
    avg_round_3: 25050,
    app_flat_3: 0,
    char_4: 'evelyn',
    app_rate_4: 9.53,
    avg_round_4: 24116,
    app_flat_4: 0,
    char_5: 'yanagi',
    app_rate_5: 9.06,
    avg_round_5: 25496,
    app_flat_5: 0,
    char_6: 'piper',
    app_rate_6: 8.76,
    avg_round_6: 22221,
    app_flat_6: 0,
    char_7: 'jane-doe',
    app_rate_7: 7.98,
    avg_round_7: 24205,
    app_flat_7: 0,
    char_8: 'anby-demara-soldier-0',
    app_rate_8: 5.84,
    avg_round_8: 23369,
    app_flat_8: 0,
    char_9: 'vivian',
    app_rate_9: 5.75,
    avg_round_9: 26255,
    app_flat_9: 0,
    char_10: 'trigger',
    app_rate_10: 5.24,
    avg_round_10: 26668,
    app_flat_10: 0,
    char_11: 'koleda',
    app_rate_11: 3.69,
    avg_round_11: 19120,
    app_flat_11: 0,
    char_12: 'soldier-11',
    app_rate_12: 3.48,
    avg_round_12: 17564,
    app_flat_12: 0,
    char_13: 'caesar',
    app_rate_13: 3.43,
    avg_round_13: 22217,
    app_flat_13: 0,
    char_14: 'astra-yao',
    app_rate_14: 3.26,
    avg_round_14: 27600,
    app_flat_14: 0,
    char_15: 'pulchra',
    app_rate_15: 2.4,
    avg_round_15: 17673,
    app_flat_15: 0,
    char_16: 'nicole-demara',
    app_rate_16: 2.02,
    avg_round_16: 21968,
    app_flat_16: 0,
    char_17: 'soukaku',
    app_rate_17: 1.85,
    avg_round_17: 21699,
    app_flat_17: 0,
    char_18: 'qingyi',
    app_rate_18: 1.85,
    avg_round_18: 19421,
    app_flat_18: 0,
    char_19: 'lycaon',
    app_rate_19: 1.46,
    avg_round_19: 19604,
    app_flat_19: 0,
    char_20: 'harumasa',
    app_rate_20: 1.37,
    avg_round_20: 17849,
    app_flat_20: 0,
    char_21: 'zhu-yuan',
    app_rate_21: 1.16,
    avg_round_21: 20211,
    app_flat_21: 0,
    char_22: 'ellen',
    app_rate_22: 0.99,
    avg_round_22: 17731,
    app_flat_22: 0,
    char_23: 'seth',
    app_rate_23: 0.77,
    avg_round_23: 14947,
    app_flat_23: 0,
    char_24: 'rina',
    app_rate_24: 0.6,
    avg_round_24: 21780,
    app_flat_24: 0,
    char_25: 'grace-howard',
    app_rate_25: 0.52,
    avg_round_25: 18140,
    app_flat_25: 0,
    char_26: 'ben',
    app_rate_26: 0.47,
    avg_round_26: 22200,
    app_flat_26: 0,
    char_27: 'anby-demara',
    app_rate_27: 0.34,
    avg_round_27: 14238,
    app_flat_27: 0,
    char_28: 'corin',
    app_rate_28: 0.26,
    avg_round_28: 21539,
    app_flat_28: 0,
    char_29: 'nekomata',
    app_rate_29: 0.21,
    avg_round_29: 19884,
    app_flat_29: 0,
    char_30: 'billy-kid',
    app_rate_30: 0.13,
    avg_round_30: 18586,
    app_flat_30: 0
  },
  {
    char: 'anby-demara-soldier-0',
    app: 37.81,
    char_1: 'trigger',
    app_rate_1: 73.42,
    avg_round_1: 28738,
    app_flat_1: 0,
    char_2: 'astra-yao',
    app_rate_2: 36.21,
    avg_round_2: 31344,
    app_flat_2: 0,
    char_3: 'pulchra',
    app_rate_3: 20.93,
    avg_round_3: 21314,
    app_flat_3: 0,
    char_4: 'caesar',
    app_rate_4: 20.57,
    avg_round_4: 25994,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 15.19,
    avg_round_5: 26917,
    app_flat_5: 0,
    char_6: 'rina',
    app_rate_6: 14.06,
    avg_round_6: 22332,
    app_flat_6: 0,
    char_7: 'qingyi',
    app_rate_7: 7.37,
    avg_round_7: 21162,
    app_flat_7: 0,
    char_8: 'lucy',
    app_rate_8: 6.15,
    avg_round_8: 23369,
    app_flat_8: 0,
    char_9: 'yanagi',
    app_rate_9: 1.85,
    avg_round_9: 18176,
    app_flat_9: 0,
    char_10: 'anby-demara',
    app_rate_10: 1.13,
    avg_round_10: 14507,
    app_flat_10: 0,
    char_11: 'harumasa',
    app_rate_11: 0.45,
    avg_round_11: 12724,
    app_flat_11: 0,
    char_12: 'vivian',
    app_rate_12: 0.36,
    avg_round_12: 20228,
    app_flat_12: 0,
    char_13: 'evelyn',
    app_rate_13: 0.32,
    avg_round_13: 17845,
    app_flat_13: 0,
    char_14: 'burnice',
    app_rate_14: 0.27,
    avg_round_14: 18557,
    app_flat_14: 0,
    char_15: 'lighter',
    app_rate_15: 0.23,
    avg_round_15: 18418,
    app_flat_15: 0,
    char_16: 'seth',
    app_rate_16: 0.23,
    avg_round_16: 11620,
    app_flat_16: 0,
    char_17: 'miyabi',
    app_rate_17: 0.18,
    avg_round_17: 13952,
    app_flat_17: 0,
    char_18: 'grace-howard',
    app_rate_18: 0.18,
    avg_round_18: 11383,
    app_flat_18: 0,
    char_19: 'zhu-yuan',
    app_rate_19: 0.18,
    avg_round_19: 13302,
    app_flat_19: 0,
    char_20: 'soldier-11',
    app_rate_20: 0.18,
    avg_round_20: 15712,
    app_flat_20: 0,
    char_21: 'koleda',
    app_rate_21: 0.14,
    avg_round_21: 15731,
    app_flat_21: 0,
    char_22: 'soukaku',
    app_rate_22: 0.14,
    avg_round_22: 14266,
    app_flat_22: 0,
    char_23: 'lycaon',
    app_rate_23: 0.09,
    avg_round_23: 8457,
    app_flat_23: 0,
    char_24: 'jane-doe',
    app_rate_24: 0.05,
    avg_round_24: 14978,
    app_flat_24: 0,
    char_25: 'piper',
    app_rate_25: 0.05,
    avg_round_25: 7069,
    app_flat_25: 0,
    char_26: 'nekomata',
    app_rate_26: 0.05,
    avg_round_26: 9205,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lycaon',
    app: 35.7,
    char_1: 'soukaku',
    app_rate_1: 61.66,
    avg_round_1: 22603,
    app_flat_1: 0,
    char_2: 'ellen',
    app_rate_2: 49.83,
    avg_round_2: 20843,
    app_flat_2: 0,
    char_3: 'miyabi',
    app_rate_3: 46.72,
    avg_round_3: 24618,
    app_flat_3: 0,
    char_4: 'astra-yao',
    app_rate_4: 13.83,
    avg_round_4: 25315,
    app_flat_4: 0,
    char_5: 'caesar',
    app_rate_5: 8.52,
    avg_round_5: 22585,
    app_flat_5: 0,
    char_6: 'nicole-demara',
    app_rate_6: 4.26,
    avg_round_6: 20458,
    app_flat_6: 0,
    char_7: 'lighter',
    app_rate_7: 3.49,
    avg_round_7: 23544,
    app_flat_7: 0,
    char_8: 'rina',
    app_rate_8: 3.35,
    avg_round_8: 17394,
    app_flat_8: 0,
    char_9: 'lucy',
    app_rate_9: 1.63,
    avg_round_9: 19604,
    app_flat_9: 0,
    char_10: 'zhu-yuan',
    app_rate_10: 1.34,
    avg_round_10: 22512,
    app_flat_10: 0,
    char_11: 'yanagi',
    app_rate_11: 1.29,
    avg_round_11: 23783,
    app_flat_11: 0,
    char_12: 'trigger',
    app_rate_12: 1.15,
    avg_round_12: 20641,
    app_flat_12: 0,
    char_13: 'harumasa',
    app_rate_13: 0.72,
    avg_round_13: 16467,
    app_flat_13: 0,
    char_14: 'burnice',
    app_rate_14: 0.72,
    avg_round_14: 20561,
    app_flat_14: 0,
    char_15: 'evelyn',
    app_rate_15: 0.57,
    avg_round_15: 21617,
    app_flat_15: 0,
    char_16: 'corin',
    app_rate_16: 0.24,
    avg_round_16: 16520,
    app_flat_16: 0,
    char_17: 'pulchra',
    app_rate_17: 0.19,
    avg_round_17: 10355,
    app_flat_17: 0,
    char_18: 'vivian',
    app_rate_18: 0.19,
    avg_round_18: 16950,
    app_flat_18: 0,
    char_19: 'qingyi',
    app_rate_19: 0.14,
    avg_round_19: 17744,
    app_flat_19: 0,
    char_20: 'jane-doe',
    app_rate_20: 0.14,
    avg_round_20: 9717,
    app_flat_20: 0,
    char_21: 'piper',
    app_rate_21: 0.14,
    avg_round_21: 9380,
    app_flat_21: 0,
    char_22: 'koleda',
    app_rate_22: 0.14,
    avg_round_22: 38278,
    app_flat_22: 0,
    char_23: 'soldier-11',
    app_rate_23: 0.1,
    avg_round_23: 39574,
    app_flat_23: 0,
    char_24: 'billy-kid',
    app_rate_24: 0.1,
    avg_round_24: 12432,
    app_flat_24: 0,
    char_25: 'anby-demara-soldier-0',
    app_rate_25: 0.1,
    avg_round_25: 8457,
    app_flat_25: 0,
    char_26: 'grace-howard',
    app_rate_26: 0.05,
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'seth',
    app_rate_27: 0.05,
    avg_round_27: 16724,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'zhu-yuan',
    app: 34.3,
    char_1: 'nicole-demara',
    app_rate_1: 85.35,
    avg_round_1: 26037,
    app_flat_1: 0,
    char_2: 'qingyi',
    app_rate_2: 67.91,
    avg_round_2: 25519,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 21.23,
    avg_round_3: 29326,
    app_flat_3: 0,
    char_4: 'anby-demara',
    app_rate_4: 5.78,
    avg_round_4: 18912,
    app_flat_4: 0,
    char_5: 'caesar',
    app_rate_5: 5.68,
    avg_round_5: 26219,
    app_flat_5: 0,
    char_6: 'trigger',
    app_rate_6: 5.58,
    avg_round_6: 26312,
    app_flat_6: 0,
    char_7: 'lycaon',
    app_rate_7: 1.4,
    avg_round_7: 22512,
    app_flat_7: 0,
    char_8: 'lucy',
    app_rate_8: 1.35,
    avg_round_8: 20211,
    app_flat_8: 0,
    char_9: 'koleda',
    app_rate_9: 1.1,
    avg_round_9: 22612,
    app_flat_9: 0,
    char_10: 'miyabi',
    app_rate_10: 0.9,
    avg_round_10: 21452,
    app_flat_10: 0,
    char_11: 'rina',
    app_rate_11: 0.7,
    avg_round_11: 17965,
    app_flat_11: 0,
    char_12: 'pulchra',
    app_rate_12: 0.65,
    avg_round_12: 17583,
    app_flat_12: 0,
    char_13: 'vivian',
    app_rate_13: 0.65,
    avg_round_13: 20496,
    app_flat_13: 0,
    char_14: 'evelyn',
    app_rate_14: 0.45,
    avg_round_14: 21510,
    app_flat_14: 0,
    char_15: 'jane-doe',
    app_rate_15: 0.4,
    avg_round_15: 15335,
    app_flat_15: 0,
    char_16: 'ellen',
    app_rate_16: 0.35,
    avg_round_16: 11907,
    app_flat_16: 0,
    char_17: 'lighter',
    app_rate_17: 0.3,
    avg_round_17: 21893,
    app_flat_17: 0,
    char_18: 'soukaku',
    app_rate_18: 0.2,
    avg_round_18: 20659,
    app_flat_18: 0,
    char_19: 'anby-demara-soldier-0',
    app_rate_19: 0.2,
    avg_round_19: 13302,
    app_flat_19: 0,
    char_20: 'yanagi',
    app_rate_20: 0.2,
    avg_round_20: 12600,
    app_flat_20: 0,
    char_21: 'burnice',
    app_rate_21: 0.15,
    avg_round_21: 10311,
    app_flat_21: 0,
    char_22: 'seth',
    app_rate_22: 0.05,
    avg_round_22: 12608,
    app_flat_22: 0,
    char_23: 'harumasa',
    app_rate_23: 0.05,
    avg_round_23: 6143,
    app_flat_23: 0,
    char_24: 'grace-howard',
    app_rate_24: 0.05,
    avg_round_24: 14362,
    app_flat_24: 0,
    char_25: 'nekomata',
    app_rate_25: 0.05,
    avg_round_25: 8383,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'caesar',
    app: 33.46,
    char_1: 'anby-demara-soldier-0',
    app_rate_1: 23.24,
    avg_round_1: 25994,
    app_flat_1: 0,
    char_2: 'trigger',
    app_rate_2: 20.12,
    avg_round_2: 27328,
    app_flat_2: 0,
    char_3: 'miyabi',
    app_rate_3: 18.64,
    avg_round_3: 22591,
    app_flat_3: 0,
    char_4: 'yanagi',
    app_rate_4: 18.18,
    avg_round_4: 24232,
    app_flat_4: 0,
    char_5: 'ellen',
    app_rate_5: 15.42,
    avg_round_5: 21917,
    app_flat_5: 0,
    char_6: 'burnice',
    app_rate_6: 13.53,
    avg_round_6: 24283,
    app_flat_6: 0,
    char_7: 'jane-doe',
    app_rate_7: 10.11,
    avg_round_7: 24848,
    app_flat_7: 0,
    char_8: 'lycaon',
    app_rate_8: 9.09,
    avg_round_8: 22585,
    app_flat_8: 0,
    char_9: 'evelyn',
    app_rate_9: 8.94,
    avg_round_9: 29251,
    app_flat_9: 0,
    char_10: 'astra-yao',
    app_rate_10: 8.48,
    avg_round_10: 28759,
    app_flat_10: 0,
    char_11: 'soukaku',
    app_rate_11: 6.89,
    avg_round_11: 20842,
    app_flat_11: 0,
    char_12: 'nicole-demara',
    app_rate_12: 6.59,
    avg_round_12: 26469,
    app_flat_12: 0,
    char_13: 'zhu-yuan',
    app_rate_13: 5.82,
    avg_round_13: 26219,
    app_flat_13: 0,
    char_14: 'vivian',
    app_rate_14: 5.11,
    avg_round_14: 27842,
    app_flat_14: 0,
    char_15: 'rina',
    app_rate_15: 4.24,
    avg_round_15: 23701,
    app_flat_15: 0,
    char_16: 'qingyi',
    app_rate_16: 4.19,
    avg_round_16: 22222,
    app_flat_16: 0,
    char_17: 'lucy',
    app_rate_17: 4.09,
    avg_round_17: 22217,
    app_flat_17: 0,
    char_18: 'harumasa',
    app_rate_18: 3.73,
    avg_round_18: 21080,
    app_flat_18: 0,
    char_19: 'pulchra',
    app_rate_19: 3.01,
    avg_round_19: 19025,
    app_flat_19: 0,
    char_20: 'lighter',
    app_rate_20: 2.76,
    avg_round_20: 31618,
    app_flat_20: 0,
    char_21: 'piper',
    app_rate_21: 2.5,
    avg_round_21: 22022,
    app_flat_21: 0,
    char_22: 'soldier-11',
    app_rate_22: 1.43,
    avg_round_22: 25994,
    app_flat_22: 0,
    char_23: 'seth',
    app_rate_23: 1.02,
    avg_round_23: 18312,
    app_flat_23: 0,
    char_24: 'koleda',
    app_rate_24: 0.66,
    avg_round_24: 18649,
    app_flat_24: 0,
    char_25: 'corin',
    app_rate_25: 0.61,
    avg_round_25: 27903,
    app_flat_25: 0,
    char_26: 'billy-kid',
    app_rate_26: 0.51,
    avg_round_26: 22498,
    app_flat_26: 0,
    char_27: 'grace-howard',
    app_rate_27: 0.51,
    avg_round_27: 14898,
    app_flat_27: 0,
    char_28: 'anby-demara',
    app_rate_28: 0.41,
    avg_round_28: 16677,
    app_flat_28: 0,
    char_29: 'nekomata',
    app_rate_29: 0.26,
    avg_round_29: 22372,
    app_flat_29: 0,
    char_30: 'anton',
    app_rate_30: 0.1,
    avg_round_30: 16161,
    app_flat_30: 0
  },
  {
    char: 'rina',
    app: 31.7,
    char_1: 'yanagi',
    app_rate_1: 45.93,
    avg_round_1: 26132,
    app_flat_1: 0,
    char_2: 'miyabi',
    app_rate_2: 33.53,
    avg_round_2: 25565,
    app_flat_2: 0,
    char_3: 'trigger',
    app_rate_3: 21.02,
    avg_round_3: 24281,
    app_flat_3: 0,
    char_4: 'harumasa',
    app_rate_4: 17.3,
    avg_round_4: 20933,
    app_flat_4: 0,
    char_5: 'anby-demara-soldier-0',
    app_rate_5: 16.77,
    avg_round_5: 22332,
    app_flat_5: 0,
    char_6: 'qingyi',
    app_rate_6: 14.34,
    avg_round_6: 22103,
    app_flat_6: 0,
    char_7: 'burnice',
    app_rate_7: 6.85,
    avg_round_7: 26733,
    app_flat_7: 0,
    char_8: 'vivian',
    app_rate_8: 5.5,
    avg_round_8: 30276,
    app_flat_8: 0,
    char_9: 'grace-howard',
    app_rate_9: 4.53,
    avg_round_9: 19456,
    app_flat_9: 0,
    char_10: 'caesar',
    app_rate_10: 4.47,
    avg_round_10: 23701,
    app_flat_10: 0,
    char_11: 'ellen',
    app_rate_11: 4.26,
    avg_round_11: 17266,
    app_flat_11: 0,
    char_12: 'lycaon',
    app_rate_12: 3.77,
    avg_round_12: 17394,
    app_flat_12: 0,
    char_13: 'seth',
    app_rate_13: 3.61,
    avg_round_13: 19351,
    app_flat_13: 0,
    char_14: 'astra-yao',
    app_rate_14: 2.8,
    avg_round_14: 26064,
    app_flat_14: 0,
    char_15: 'anby-demara',
    app_rate_15: 2.8,
    avg_round_15: 16728,
    app_flat_15: 0,
    char_16: 'pulchra',
    app_rate_16: 2.43,
    avg_round_16: 17169,
    app_flat_16: 0,
    char_17: 'soukaku',
    app_rate_17: 1.78,
    avg_round_17: 17983,
    app_flat_17: 0,
    char_18: 'jane-doe',
    app_rate_18: 1.78,
    avg_round_18: 15737,
    app_flat_18: 0,
    char_19: 'nicole-demara',
    app_rate_19: 1.51,
    avg_round_19: 21349,
    app_flat_19: 0,
    char_20: 'evelyn',
    app_rate_20: 0.97,
    avg_round_20: 17452,
    app_flat_20: 0,
    char_21: 'zhu-yuan',
    app_rate_21: 0.75,
    avg_round_21: 17965,
    app_flat_21: 0,
    char_22: 'lucy',
    app_rate_22: 0.75,
    avg_round_22: 21780,
    app_flat_22: 0,
    char_23: 'corin',
    app_rate_23: 0.7,
    avg_round_23: 25734,
    app_flat_23: 0,
    char_24: 'anton',
    app_rate_24: 0.43,
    avg_round_24: 16091,
    app_flat_24: 0,
    char_25: 'koleda',
    app_rate_25: 0.38,
    avg_round_25: 15123,
    app_flat_25: 0,
    char_26: 'lighter',
    app_rate_26: 0.32,
    avg_round_26: 15722,
    app_flat_26: 0,
    char_27: 'piper',
    app_rate_27: 0.27,
    avg_round_27: 22677,
    app_flat_27: 0,
    char_28: 'soldier-11',
    app_rate_28: 0.11,
    avg_round_28: 7290,
    app_flat_28: 0,
    char_29: 'nekomata',
    app_rate_29: 0.11,
    avg_round_29: 17489,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'ellen',
    app: 25.43,
    char_1: 'lycaon',
    app_rate_1: 69.96,
    avg_round_1: 20843,
    app_flat_1: 0,
    char_2: 'soukaku',
    app_rate_2: 51.14,
    avg_round_2: 19644,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 21.3,
    avg_round_3: 23903,
    app_flat_3: 0,
    char_4: 'caesar',
    app_rate_4: 20.3,
    avg_round_4: 21917,
    app_flat_4: 0,
    char_5: 'lighter',
    app_rate_5: 11.36,
    avg_round_5: 22172,
    app_flat_5: 0,
    char_6: 'rina',
    app_rate_6: 5.31,
    avg_round_6: 17266,
    app_flat_6: 0,
    char_7: 'nicole-demara',
    app_rate_7: 5.04,
    avg_round_7: 20122,
    app_flat_7: 0,
    char_8: 'trigger',
    app_rate_8: 4.64,
    avg_round_8: 21678,
    app_flat_8: 0,
    char_9: 'qingyi',
    app_rate_9: 2.62,
    avg_round_9: 19172,
    app_flat_9: 0,
    char_10: 'miyabi',
    app_rate_10: 2.28,
    avg_round_10: 19597,
    app_flat_10: 0,
    char_11: 'lucy',
    app_rate_11: 1.55,
    avg_round_11: 17731,
    app_flat_11: 0,
    char_12: 'vivian',
    app_rate_12: 0.67,
    avg_round_12: 17287,
    app_flat_12: 0,
    char_13: 'koleda',
    app_rate_13: 0.6,
    avg_round_13: 21789,
    app_flat_13: 0,
    char_14: 'anby-demara',
    app_rate_14: 0.6,
    avg_round_14: 14522,
    app_flat_14: 0,
    char_15: 'burnice',
    app_rate_15: 0.6,
    avg_round_15: 13770,
    app_flat_15: 0,
    char_16: 'evelyn',
    app_rate_16: 0.47,
    avg_round_16: 17704,
    app_flat_16: 0,
    char_17: 'zhu-yuan',
    app_rate_17: 0.47,
    avg_round_17: 11907,
    app_flat_17: 0,
    char_18: 'pulchra',
    app_rate_18: 0.4,
    avg_round_18: 11788,
    app_flat_18: 0,
    char_19: 'yanagi',
    app_rate_19: 0.34,
    avg_round_19: 13649,
    app_flat_19: 0,
    char_20: 'jane-doe',
    app_rate_20: 0.27,
    avg_round_20: 11643,
    app_flat_20: 0,
    char_21: 'harumasa',
    app_rate_21: 0.2,
    avg_round_21: 47001,
    app_flat_21: 0,
    char_22: 'corin',
    app_rate_22: 0.07,
    avg_round_22: 60000,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'evelyn',
    app: 24.12,
    char_1: 'astra-yao',
    app_rate_1: 78.17,
    avg_round_1: 30606,
    app_flat_1: 0,
    char_2: 'lighter',
    app_rate_2: 27.5,
    avg_round_2: 32865,
    app_flat_2: 0,
    char_3: 'koleda',
    app_rate_3: 25.73,
    avg_round_3: 25888,
    app_flat_3: 0,
    char_4: 'lucy',
    app_rate_4: 15.73,
    avg_round_4: 24116,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 12.83,
    avg_round_5: 30378,
    app_flat_5: 0,
    char_6: 'caesar',
    app_rate_6: 12.4,
    avg_round_6: 29251,
    app_flat_6: 0,
    char_7: 'trigger',
    app_rate_7: 11.48,
    avg_round_7: 31274,
    app_flat_7: 0,
    char_8: 'qingyi',
    app_rate_8: 5.32,
    avg_round_8: 27101,
    app_flat_8: 0,
    char_9: 'burnice',
    app_rate_9: 2.83,
    avg_round_9: 20160,
    app_flat_9: 0,
    char_10: 'miyabi',
    app_rate_10: 1.77,
    avg_round_10: 26044,
    app_flat_10: 0,
    char_11: 'pulchra',
    app_rate_11: 1.77,
    avg_round_11: 19443,
    app_flat_11: 0,
    char_12: 'rina',
    app_rate_12: 1.28,
    avg_round_12: 17452,
    app_flat_12: 0,
    char_13: 'lycaon',
    app_rate_13: 0.85,
    avg_round_13: 21617,
    app_flat_13: 0,
    char_14: 'yanagi',
    app_rate_14: 0.78,
    avg_round_14: 15867,
    app_flat_14: 0,
    char_15: 'jane-doe',
    app_rate_15: 0.71,
    avg_round_15: 13576,
    app_flat_15: 0,
    char_16: 'vivian',
    app_rate_16: 0.64,
    avg_round_16: 25169,
    app_flat_16: 0,
    char_17: 'zhu-yuan',
    app_rate_17: 0.64,
    avg_round_17: 21510,
    app_flat_17: 0,
    char_18: 'anby-demara',
    app_rate_18: 0.64,
    avg_round_18: 13504,
    app_flat_18: 0,
    char_19: 'ellen',
    app_rate_19: 0.5,
    avg_round_19: 17704,
    app_flat_19: 0,
    char_20: 'anby-demara-soldier-0',
    app_rate_20: 0.5,
    avg_round_20: 17845,
    app_flat_20: 0,
    char_21: 'soukaku',
    app_rate_21: 0.43,
    avg_round_21: 21228,
    app_flat_21: 0,
    char_22: 'ben',
    app_rate_22: 0.28,
    avg_round_22: 20429,
    app_flat_22: 0,
    char_23: 'seth',
    app_rate_23: 0.28,
    avg_round_23: 9407,
    app_flat_23: 0,
    char_24: 'nekomata',
    app_rate_24: 0.21,
    avg_round_24: 13012,
    app_flat_24: 0,
    char_25: 'soldier-11',
    app_rate_25: 0.21,
    avg_round_25: 20138,
    app_flat_25: 0,
    char_26: 'piper',
    app_rate_26: 0.07,
    avg_round_26: 12414,
    app_flat_26: 0,
    char_27: 'grace-howard',
    app_rate_27: 0.07,
    avg_round_27: 13418,
    app_flat_27: 0,
    char_28: 'harumasa',
    app_rate_28: 0.07,
    avg_round_28: 7757,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'vivian',
    app: 21.48,
    char_1: 'astra-yao',
    app_rate_1: 42.32,
    avg_round_1: 39716,
    app_flat_1: 0,
    char_2: 'jane-doe',
    app_rate_2: 36.28,
    avg_round_2: 31485,
    app_flat_2: 0,
    char_3: 'yanagi',
    app_rate_3: 27.21,
    avg_round_3: 36574,
    app_flat_3: 0,
    char_4: 'miyabi',
    app_rate_4: 20.68,
    avg_round_4: 32788,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 16.87,
    avg_round_5: 28371,
    app_flat_5: 0,
    char_6: 'burnice',
    app_rate_6: 13.44,
    avg_round_6: 27510,
    app_flat_6: 0,
    char_7: 'lucy',
    app_rate_7: 10.66,
    avg_round_7: 26255,
    app_flat_7: 0,
    char_8: 'rina',
    app_rate_8: 8.11,
    avg_round_8: 30276,
    app_flat_8: 0,
    char_9: 'caesar',
    app_rate_9: 7.96,
    avg_round_9: 27842,
    app_flat_9: 0,
    char_10: 'piper',
    app_rate_10: 5.97,
    avg_round_10: 26258,
    app_flat_10: 0,
    char_11: 'seth',
    app_rate_11: 4.85,
    avg_round_11: 19872,
    app_flat_11: 0,
    char_12: 'soukaku',
    app_rate_12: 3.98,
    avg_round_12: 27840,
    app_flat_12: 0,
    char_13: 'trigger',
    app_rate_13: 2.63,
    avg_round_13: 28299,
    app_flat_13: 0,
    char_14: 'grace-howard',
    app_rate_14: 1.99,
    avg_round_14: 24904,
    app_flat_14: 0,
    char_15: 'zhu-yuan',
    app_rate_15: 1.03,
    avg_round_15: 20496,
    app_flat_15: 0,
    char_16: 'ellen',
    app_rate_16: 0.8,
    avg_round_16: 17287,
    app_flat_16: 0,
    char_17: 'evelyn',
    app_rate_17: 0.72,
    avg_round_17: 25169,
    app_flat_17: 0,
    char_18: 'anby-demara-soldier-0',
    app_rate_18: 0.64,
    avg_round_18: 20228,
    app_flat_18: 0,
    char_19: 'harumasa',
    app_rate_19: 0.64,
    avg_round_19: 18341,
    app_flat_19: 0,
    char_20: 'qingyi',
    app_rate_20: 0.56,
    avg_round_20: 13164,
    app_flat_20: 0,
    char_21: 'lycaon',
    app_rate_21: 0.32,
    avg_round_21: 16950,
    app_flat_21: 0,
    char_22: 'nekomata',
    app_rate_22: 0.16,
    avg_round_22: 16936,
    app_flat_22: 0,
    char_23: 'koleda',
    app_rate_23: 0.16,
    avg_round_23: 12488,
    app_flat_23: 0,
    char_24: 'pulchra',
    app_rate_24: 0.08,
    avg_round_24: 6357,
    app_flat_24: 0,
    char_25: 'soldier-11',
    app_rate_25: 0.08,
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'lighter',
    app_rate_26: 0.08,
    avg_round_26: 8854,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'harumasa',
    app: 17.95,
    char_1: 'qingyi',
    app_rate_1: 56.19,
    avg_round_1: 23856,
    app_flat_1: 0,
    char_2: 'rina',
    app_rate_2: 30.57,
    avg_round_2: 20933,
    app_flat_2: 0,
    char_3: 'trigger',
    app_rate_3: 23.71,
    avg_round_3: 23065,
    app_flat_3: 0,
    char_4: 'astra-yao',
    app_rate_4: 23.43,
    avg_round_4: 25121,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 22.48,
    avg_round_5: 22591,
    app_flat_5: 0,
    char_6: 'anby-demara',
    app_rate_6: 11.52,
    avg_round_6: 18130,
    app_flat_6: 0,
    char_7: 'caesar',
    app_rate_7: 6.95,
    avg_round_7: 21080,
    app_flat_7: 0,
    char_8: 'yanagi',
    app_rate_8: 4.48,
    avg_round_8: 19756,
    app_flat_8: 0,
    char_9: 'miyabi',
    app_rate_9: 4.38,
    avg_round_9: 22708,
    app_flat_9: 0,
    char_10: 'grace-howard',
    app_rate_10: 3.24,
    avg_round_10: 17652,
    app_flat_10: 0,
    char_11: 'lucy',
    app_rate_11: 3.05,
    avg_round_11: 17849,
    app_flat_11: 0,
    char_12: 'lycaon',
    app_rate_12: 1.43,
    avg_round_12: 16467,
    app_flat_12: 0,
    char_13: 'soukaku',
    app_rate_13: 1.24,
    avg_round_13: 18774,
    app_flat_13: 0,
    char_14: 'seth',
    app_rate_14: 1.14,
    avg_round_14: 17248,
    app_flat_14: 0,
    char_15: 'pulchra',
    app_rate_15: 1.05,
    avg_round_15: 13814,
    app_flat_15: 0,
    char_16: 'anby-demara-soldier-0',
    app_rate_16: 0.95,
    avg_round_16: 12724,
    app_flat_16: 0,
    char_17: 'burnice',
    app_rate_17: 0.76,
    avg_round_17: 14510,
    app_flat_17: 0,
    char_18: 'vivian',
    app_rate_18: 0.76,
    avg_round_18: 18341,
    app_flat_18: 0,
    char_19: 'koleda',
    app_rate_19: 0.67,
    avg_round_19: 16865,
    app_flat_19: 0,
    char_20: 'lighter',
    app_rate_20: 0.57,
    avg_round_20: 11678,
    app_flat_20: 0,
    char_21: 'piper',
    app_rate_21: 0.38,
    avg_round_21: 10111,
    app_flat_21: 0,
    char_22: 'ellen',
    app_rate_22: 0.29,
    avg_round_22: 47001,
    app_flat_22: 0,
    char_23: 'jane-doe',
    app_rate_23: 0.19,
    avg_round_23: 12963,
    app_flat_23: 0,
    char_24: 'anton',
    app_rate_24: 0.19,
    avg_round_24: 39805,
    app_flat_24: 0,
    char_25: 'corin',
    app_rate_25: 0.1,
    avg_round_25: 20526,
    app_flat_25: 0,
    char_26: 'zhu-yuan',
    app_rate_26: 0.1,
    avg_round_26: 6143,
    app_flat_26: 0,
    char_27: 'evelyn',
    app_rate_27: 0.1,
    avg_round_27: 7757,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jane-doe',
    app: 17.74,
    char_1: 'vivian',
    app_rate_1: 43.93,
    avg_round_1: 31485,
    app_flat_1: 0,
    char_2: 'burnice',
    app_rate_2: 41.23,
    avg_round_2: 23942,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 30.35,
    avg_round_3: 35374,
    app_flat_3: 0,
    char_4: 'caesar',
    app_rate_4: 19.08,
    avg_round_4: 24848,
    app_flat_4: 0,
    char_5: 'seth',
    app_rate_5: 18.79,
    avg_round_5: 16745,
    app_flat_5: 0,
    char_6: 'lucy',
    app_rate_6: 17.92,
    avg_round_6: 24205,
    app_flat_6: 0,
    char_7: 'nicole-demara',
    app_rate_7: 9.83,
    avg_round_7: 24479,
    app_flat_7: 0,
    char_8: 'rina',
    app_rate_8: 3.18,
    avg_round_8: 15737,
    app_flat_8: 0,
    char_9: 'trigger',
    app_rate_9: 2.7,
    avg_round_9: 22107,
    app_flat_9: 0,
    char_10: 'miyabi',
    app_rate_10: 2.41,
    avg_round_10: 24688,
    app_flat_10: 0,
    char_11: 'yanagi',
    app_rate_11: 2.12,
    avg_round_11: 24369,
    app_flat_11: 0,
    char_12: 'qingyi',
    app_rate_12: 1.83,
    avg_round_12: 16820,
    app_flat_12: 0,
    char_13: 'grace-howard',
    app_rate_13: 1.64,
    avg_round_13: 16725,
    app_flat_13: 0,
    char_14: 'soukaku',
    app_rate_14: 1.06,
    avg_round_14: 18629,
    app_flat_14: 0,
    char_15: 'piper',
    app_rate_15: 0.96,
    avg_round_15: 13986,
    app_flat_15: 0,
    char_16: 'evelyn',
    app_rate_16: 0.96,
    avg_round_16: 13576,
    app_flat_16: 0,
    char_17: 'zhu-yuan',
    app_rate_17: 0.77,
    avg_round_17: 15335,
    app_flat_17: 0,
    char_18: 'pulchra',
    app_rate_18: 0.58,
    avg_round_18: 15183,
    app_flat_18: 0,
    char_19: 'koleda',
    app_rate_19: 0.58,
    avg_round_19: 14089,
    app_flat_19: 0,
    char_20: 'ellen',
    app_rate_20: 0.39,
    avg_round_20: 11643,
    app_flat_20: 0,
    char_21: 'anby-demara',
    app_rate_21: 0.39,
    avg_round_21: 11365,
    app_flat_21: 0,
    char_22: 'lighter',
    app_rate_22: 0.29,
    avg_round_22: 20642,
    app_flat_22: 0,
    char_23: 'lycaon',
    app_rate_23: 0.29,
    avg_round_23: 9717,
    app_flat_23: 0,
    char_24: 'nekomata',
    app_rate_24: 0.29,
    avg_round_24: 10158,
    app_flat_24: 0,
    char_25: 'harumasa',
    app_rate_25: 0.19,
    avg_round_25: 12963,
    app_flat_25: 0,
    char_26: 'soldier-11',
    app_rate_26: 0.19,
    avg_round_26: 10302,
    app_flat_26: 0,
    char_27: 'billy-kid',
    app_rate_27: 0.19,
    avg_round_27: 11803,
    app_flat_27: 0,
    char_28: 'anby-demara-soldier-0',
    app_rate_28: 0.1,
    avg_round_28: 14978,
    app_flat_28: 0,
    char_29: 'ben',
    app_rate_29: 0.1,
    avg_round_29: 14805,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lighter',
    app: 13.84,
    char_1: 'evelyn',
    app_rate_1: 47.9,
    avg_round_1: 32865,
    app_flat_1: 0,
    char_2: 'astra-yao',
    app_rate_2: 40.49,
    avg_round_2: 34054,
    app_flat_2: 0,
    char_3: 'lucy',
    app_rate_3: 29.38,
    avg_round_3: 25050,
    app_flat_3: 0,
    char_4: 'ellen',
    app_rate_4: 20.86,
    avg_round_4: 22172,
    app_flat_4: 0,
    char_5: 'miyabi',
    app_rate_5: 20.37,
    avg_round_5: 24578,
    app_flat_5: 0,
    char_6: 'lycaon',
    app_rate_6: 9.01,
    avg_round_6: 23544,
    app_flat_6: 0,
    char_7: 'soukaku',
    app_rate_7: 8.52,
    avg_round_7: 20620,
    app_flat_7: 0,
    char_8: 'soldier-11',
    app_rate_8: 7.28,
    avg_round_8: 26207,
    app_flat_8: 0,
    char_9: 'caesar',
    app_rate_9: 6.67,
    avg_round_9: 31618,
    app_flat_9: 0,
    char_10: 'burnice',
    app_rate_10: 4.2,
    avg_round_10: 22911,
    app_flat_10: 0,
    char_11: 'nicole-demara',
    app_rate_11: 1.98,
    avg_round_11: 19588,
    app_flat_11: 0,
    char_12: 'trigger',
    app_rate_12: 1.6,
    avg_round_12: 27769,
    app_flat_12: 0,
    char_13: 'ben',
    app_rate_13: 1.36,
    avg_round_13: 22805,
    app_flat_13: 0,
    char_14: 'zhu-yuan',
    app_rate_14: 0.74,
    avg_round_14: 21893,
    app_flat_14: 0,
    char_15: 'harumasa',
    app_rate_15: 0.74,
    avg_round_15: 11678,
    app_flat_15: 0,
    char_16: 'rina',
    app_rate_16: 0.74,
    avg_round_16: 15722,
    app_flat_16: 0,
    char_17: 'anby-demara-soldier-0',
    app_rate_17: 0.62,
    avg_round_17: 18418,
    app_flat_17: 0,
    char_18: 'koleda',
    app_rate_18: 0.49,
    avg_round_18: 27508,
    app_flat_18: 0,
    char_19: 'yanagi',
    app_rate_19: 0.49,
    avg_round_19: 17436,
    app_flat_19: 0,
    char_20: 'jane-doe',
    app_rate_20: 0.37,
    avg_round_20: 20642,
    app_flat_20: 0,
    char_21: 'qingyi',
    app_rate_21: 0.25,
    avg_round_21: 6234,
    app_flat_21: 0,
    char_22: 'pulchra',
    app_rate_22: 0.25,
    avg_round_22: 8034,
    app_flat_22: 0,
    char_23: 'billy-kid',
    app_rate_23: 0.12,
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'corin',
    app_rate_24: 0.12,
    avg_round_24: 10990,
    app_flat_24: 0,
    char_25: 'piper',
    app_rate_25: 0.12,
    avg_round_25: 10990,
    app_flat_25: 0,
    char_26: 'vivian',
    app_rate_26: 0.12,
    avg_round_26: 8854,
    app_flat_26: 0,
    char_27: 'nekomata',
    app_rate_27: 0.12,
    avg_round_27: 14064,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'pulchra',
    app: 9.66,
    char_1: 'anby-demara-soldier-0',
    app_rate_1: 81.95,
    avg_round_1: 21314,
    app_flat_1: 0,
    char_2: 'trigger',
    app_rate_2: 32.39,
    avg_round_2: 22953,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 21.95,
    avg_round_3: 24561,
    app_flat_3: 0,
    char_4: 'caesar',
    app_rate_4: 10.44,
    avg_round_4: 19025,
    app_flat_4: 0,
    char_5: 'lucy',
    app_rate_5: 9.91,
    avg_round_5: 17673,
    app_flat_5: 0,
    char_6: 'rina',
    app_rate_6: 7.96,
    avg_round_6: 17169,
    app_flat_6: 0,
    char_7: 'nicole-demara',
    app_rate_7: 7.43,
    avg_round_7: 20390,
    app_flat_7: 0,
    char_8: 'evelyn',
    app_rate_8: 4.42,
    avg_round_8: 19443,
    app_flat_8: 0,
    char_9: 'miyabi',
    app_rate_9: 3.54,
    avg_round_9: 15428,
    app_flat_9: 0,
    char_10: 'qingyi',
    app_rate_10: 2.83,
    avg_round_10: 15435,
    app_flat_10: 0,
    char_11: 'zhu-yuan',
    app_rate_11: 2.3,
    avg_round_11: 17583,
    app_flat_11: 0,
    char_12: 'burnice',
    app_rate_12: 2.12,
    avg_round_12: 20929,
    app_flat_12: 0,
    char_13: 'harumasa',
    app_rate_13: 1.95,
    avg_round_13: 13814,
    app_flat_13: 0,
    char_14: 'soukaku',
    app_rate_14: 1.77,
    avg_round_14: 14046,
    app_flat_14: 0,
    char_15: 'piper',
    app_rate_15: 1.24,
    avg_round_15: 22004,
    app_flat_15: 0,
    char_16: 'ellen',
    app_rate_16: 1.06,
    avg_round_16: 11788,
    app_flat_16: 0,
    char_17: 'jane-doe',
    app_rate_17: 1.06,
    avg_round_17: 15183,
    app_flat_17: 0,
    char_18: 'nekomata',
    app_rate_18: 1.06,
    avg_round_18: 21969,
    app_flat_18: 0,
    char_19: 'billy-kid',
    app_rate_19: 0.88,
    avg_round_19: 22668,
    app_flat_19: 0,
    char_20: 'soldier-11',
    app_rate_20: 0.71,
    avg_round_20: 16526,
    app_flat_20: 0,
    char_21: 'lycaon',
    app_rate_21: 0.71,
    avg_round_21: 10355,
    app_flat_21: 0,
    char_22: 'yanagi',
    app_rate_22: 0.71,
    avg_round_22: 20968,
    app_flat_22: 0,
    char_23: 'grace-howard',
    app_rate_23: 0.35,
    avg_round_23: 14122,
    app_flat_23: 0,
    char_24: 'corin',
    app_rate_24: 0.35,
    avg_round_24: 12838,
    app_flat_24: 0,
    char_25: 'lighter',
    app_rate_25: 0.35,
    avg_round_25: 8034,
    app_flat_25: 0,
    char_26: 'koleda',
    app_rate_26: 0.18,
    avg_round_26: 11111,
    app_flat_26: 0,
    char_27: 'vivian',
    app_rate_27: 0.18,
    avg_round_27: 6357,
    app_flat_27: 0,
    char_28: 'anby-demara',
    app_rate_28: 0.18,
    avg_round_28: 9306,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'koleda',
    app: 7.86,
    char_1: 'evelyn',
    app_rate_1: 78.91,
    avg_round_1: 25888,
    app_flat_1: 0,
    char_2: 'astra-yao',
    app_rate_2: 63.48,
    avg_round_2: 27423,
    app_flat_2: 0,
    char_3: 'lucy',
    app_rate_3: 18.7,
    avg_round_3: 19120,
    app_flat_3: 0,
    char_4: 'soldier-11',
    app_rate_4: 5.87,
    avg_round_4: 19410,
    app_flat_4: 0,
    char_5: 'nicole-demara',
    app_rate_5: 5.43,
    avg_round_5: 24528,
    app_flat_5: 0,
    char_6: 'zhu-yuan',
    app_rate_6: 4.78,
    avg_round_6: 22612,
    app_flat_6: 0,
    char_7: 'miyabi',
    app_rate_7: 3.91,
    avg_round_7: 19162,
    app_flat_7: 0,
    char_8: 'caesar',
    app_rate_8: 2.83,
    avg_round_8: 18649,
    app_flat_8: 0,
    char_9: 'burnice',
    app_rate_9: 1.96,
    avg_round_9: 15229,
    app_flat_9: 0,
    char_10: 'ellen',
    app_rate_10: 1.96,
    avg_round_10: 21789,
    app_flat_10: 0,
    char_11: 'soukaku',
    app_rate_11: 1.52,
    avg_round_11: 17648,
    app_flat_11: 0,
    char_12: 'harumasa',
    app_rate_12: 1.52,
    avg_round_12: 16865,
    app_flat_12: 0,
    char_13: 'rina',
    app_rate_13: 1.52,
    avg_round_13: 15123,
    app_flat_13: 0,
    char_14: 'trigger',
    app_rate_14: 1.3,
    avg_round_14: 23550,
    app_flat_14: 0,
    char_15: 'jane-doe',
    app_rate_15: 1.3,
    avg_round_15: 14089,
    app_flat_15: 0,
    char_16: 'grace-howard',
    app_rate_16: 1.09,
    avg_round_16: 22910,
    app_flat_16: 0,
    char_17: 'lighter',
    app_rate_17: 0.87,
    avg_round_17: 27508,
    app_flat_17: 0,
    char_18: 'anby-demara-soldier-0',
    app_rate_18: 0.65,
    avg_round_18: 15731,
    app_flat_18: 0,
    char_19: 'ben',
    app_rate_19: 0.65,
    avg_round_19: 14376,
    app_flat_19: 0,
    char_20: 'lycaon',
    app_rate_20: 0.65,
    avg_round_20: 38278,
    app_flat_20: 0,
    char_21: 'vivian',
    app_rate_21: 0.43,
    avg_round_21: 12488,
    app_flat_21: 0,
    char_22: 'seth',
    app_rate_22: 0.43,
    avg_round_22: 10948,
    app_flat_22: 0,
    char_23: 'pulchra',
    app_rate_23: 0.22,
    avg_round_23: 11111,
    app_flat_23: 0,
    char_24: 'nekomata',
    app_rate_24: 0.22,
    avg_round_24: 13429,
    app_flat_24: 0,
    char_25: 'piper',
    app_rate_25: 0.22,
    avg_round_25: 8931,
    app_flat_25: 0,
    char_26: 'qingyi',
    app_rate_26: 0.22,
    avg_round_26: 12776,
    app_flat_26: 0,
    char_27: 'billy-kid',
    app_rate_27: 0.22,
    avg_round_27: 7688,
    app_flat_27: 0,
    char_28: 'yanagi',
    app_rate_28: 0.22,
    avg_round_28: 16574,
    app_flat_28: 0,
    char_29: 'anton',
    app_rate_29: 0.22,
    avg_round_29: 61600,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'piper',
    app: 6.31,
    char_1: 'lucy',
    app_rate_1: 55.28,
    avg_round_1: 22221,
    app_flat_1: 0,
    char_2: 'burnice',
    app_rate_2: 39.57,
    avg_round_2: 22725,
    app_flat_2: 0,
    char_3: 'miyabi',
    app_rate_3: 27.64,
    avg_round_3: 22811,
    app_flat_3: 0,
    char_4: 'vivian',
    app_rate_4: 20.33,
    avg_round_4: 26258,
    app_flat_4: 0,
    char_5: 'astra-yao',
    app_rate_5: 16.53,
    avg_round_5: 28634,
    app_flat_5: 0,
    char_6: 'caesar',
    app_rate_6: 13.28,
    avg_round_6: 22022,
    app_flat_6: 0,
    char_7: 'nicole-demara',
    app_rate_7: 6.23,
    avg_round_7: 26416,
    app_flat_7: 0,
    char_8: 'yanagi',
    app_rate_8: 3.52,
    avg_round_8: 20024,
    app_flat_8: 0,
    char_9: 'jane-doe',
    app_rate_9: 2.71,
    avg_round_9: 13986,
    app_flat_9: 0,
    char_10: 'soukaku',
    app_rate_10: 2.44,
    avg_round_10: 19421,
    app_flat_10: 0,
    char_11: 'grace-howard',
    app_rate_11: 1.9,
    avg_round_11: 16145,
    app_flat_11: 0,
    char_12: 'pulchra',
    app_rate_12: 1.9,
    avg_round_12: 22004,
    app_flat_12: 0,
    char_13: 'seth',
    app_rate_13: 1.63,
    avg_round_13: 10006,
    app_flat_13: 0,
    char_14: 'rina',
    app_rate_14: 1.36,
    avg_round_14: 22677,
    app_flat_14: 0,
    char_15: 'corin',
    app_rate_15: 1.08,
    avg_round_15: 17349,
    app_flat_15: 0,
    char_16: 'harumasa',
    app_rate_16: 1.08,
    avg_round_16: 10111,
    app_flat_16: 0,
    char_17: 'lycaon',
    app_rate_17: 0.81,
    avg_round_17: 9380,
    app_flat_17: 0,
    char_18: 'trigger',
    app_rate_18: 0.54,
    avg_round_18: 39087,
    app_flat_18: 0,
    char_19: 'billy-kid',
    app_rate_19: 0.54,
    avg_round_19: 14659,
    app_flat_19: 0,
    char_20: 'lighter',
    app_rate_20: 0.27,
    avg_round_20: 10990,
    app_flat_20: 0,
    char_21: 'soldier-11',
    app_rate_21: 0.27,
    avg_round_21: 12154,
    app_flat_21: 0,
    char_22: 'koleda',
    app_rate_22: 0.27,
    avg_round_22: 8931,
    app_flat_22: 0,
    char_23: 'evelyn',
    app_rate_23: 0.27,
    avg_round_23: 12414,
    app_flat_23: 0,
    char_24: 'anby-demara',
    app_rate_24: 0.27,
    avg_round_24: 12414,
    app_flat_24: 0,
    char_25: 'anby-demara-soldier-0',
    app_rate_25: 0.27,
    avg_round_25: 7069,
    app_flat_25: 0,
    char_26: 'nekomata',
    app_rate_26: 0.27,
    avg_round_26: 16661,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'seth',
    app: 6.02,
    char_1: 'jane-doe',
    app_rate_1: 55.4,
    avg_round_1: 16745,
    app_flat_1: 0,
    char_2: 'yanagi',
    app_rate_2: 32.95,
    avg_round_2: 21041,
    app_flat_2: 0,
    char_3: 'rina',
    app_rate_3: 19.03,
    avg_round_3: 19351,
    app_flat_3: 0,
    char_4: 'vivian',
    app_rate_4: 17.33,
    avg_round_4: 19872,
    app_flat_4: 0,
    char_5: 'burnice',
    app_rate_5: 15.06,
    avg_round_5: 18753,
    app_flat_5: 0,
    char_6: 'miyabi',
    app_rate_6: 11.36,
    avg_round_6: 19029,
    app_flat_6: 0,
    char_7: 'astra-yao',
    app_rate_7: 9.38,
    avg_round_7: 20302,
    app_flat_7: 0,
    char_8: 'trigger',
    app_rate_8: 5.68,
    avg_round_8: 16714,
    app_flat_8: 0,
    char_9: 'caesar',
    app_rate_9: 5.68,
    avg_round_9: 18312,
    app_flat_9: 0,
    char_10: 'lucy',
    app_rate_10: 5.11,
    avg_round_10: 14947,
    app_flat_10: 0,
    char_11: 'nicole-demara',
    app_rate_11: 5.11,
    avg_round_11: 16129,
    app_flat_11: 0,
    char_12: 'harumasa',
    app_rate_12: 3.41,
    avg_round_12: 17248,
    app_flat_12: 0,
    char_13: 'grace-howard',
    app_rate_13: 2.56,
    avg_round_13: 11927,
    app_flat_13: 0,
    char_14: 'piper',
    app_rate_14: 1.7,
    avg_round_14: 10006,
    app_flat_14: 0,
    char_15: 'soukaku',
    app_rate_15: 1.7,
    avg_round_15: 13123,
    app_flat_15: 0,
    char_16: 'qingyi',
    app_rate_16: 1.7,
    avg_round_16: 15060,
    app_flat_16: 0,
    char_17: 'anby-demara',
    app_rate_17: 1.42,
    avg_round_17: 10271,
    app_flat_17: 0,
    char_18: 'anby-demara-soldier-0',
    app_rate_18: 1.42,
    avg_round_18: 11620,
    app_flat_18: 0,
    char_19: 'evelyn',
    app_rate_19: 1.14,
    avg_round_19: 9407,
    app_flat_19: 0,
    char_20: 'anton',
    app_rate_20: 0.57,
    avg_round_20: 40016,
    app_flat_20: 0,
    char_21: 'koleda',
    app_rate_21: 0.57,
    avg_round_21: 10948,
    app_flat_21: 0,
    char_22: 'zhu-yuan',
    app_rate_22: 0.28,
    avg_round_22: 12608,
    app_flat_22: 0,
    char_23: 'lycaon',
    app_rate_23: 0.28,
    avg_round_23: 16724,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'anby-demara',
    app: 5.4,
    char_1: 'nicole-demara',
    app_rate_1: 52.53,
    avg_round_1: 18860,
    app_flat_1: 0,
    char_2: 'harumasa',
    app_rate_2: 38.29,
    avg_round_2: 18130,
    app_flat_2: 0,
    char_3: 'zhu-yuan',
    app_rate_3: 36.71,
    avg_round_3: 18912,
    app_flat_3: 0,
    char_4: 'rina',
    app_rate_4: 16.46,
    avg_round_4: 16728,
    app_flat_4: 0,
    char_5: 'astra-yao',
    app_rate_5: 13.92,
    avg_round_5: 19372,
    app_flat_5: 0,
    char_6: 'anby-demara-soldier-0',
    app_rate_6: 7.91,
    avg_round_6: 14507,
    app_flat_6: 0,
    char_7: 'trigger',
    app_rate_7: 4.11,
    avg_round_7: 16032,
    app_flat_7: 0,
    char_8: 'yanagi',
    app_rate_8: 3.8,
    avg_round_8: 18098,
    app_flat_8: 0,
    char_9: 'ellen',
    app_rate_9: 2.85,
    avg_round_9: 14522,
    app_flat_9: 0,
    char_10: 'evelyn',
    app_rate_10: 2.85,
    avg_round_10: 13504,
    app_flat_10: 0,
    char_11: 'miyabi',
    app_rate_11: 2.53,
    avg_round_11: 30809,
    app_flat_11: 0,
    char_12: 'soukaku',
    app_rate_12: 2.53,
    avg_round_12: 16818,
    app_flat_12: 0,
    char_13: 'lucy',
    app_rate_13: 2.53,
    avg_round_13: 14238,
    app_flat_13: 0,
    char_14: 'caesar',
    app_rate_14: 2.53,
    avg_round_14: 16677,
    app_flat_14: 0,
    char_15: 'qingyi',
    app_rate_15: 1.9,
    avg_round_15: 10859,
    app_flat_15: 0,
    char_16: 'seth',
    app_rate_16: 1.58,
    avg_round_16: 10271,
    app_flat_16: 0,
    char_17: 'anton',
    app_rate_17: 1.27,
    avg_round_17: 18806,
    app_flat_17: 0,
    char_18: 'soldier-11',
    app_rate_18: 1.27,
    avg_round_18: 10570,
    app_flat_18: 0,
    char_19: 'nekomata',
    app_rate_19: 1.27,
    avg_round_19: 20285,
    app_flat_19: 0,
    char_20: 'jane-doe',
    app_rate_20: 1.27,
    avg_round_20: 11365,
    app_flat_20: 0,
    char_21: 'corin',
    app_rate_21: 0.63,
    avg_round_21: 16907,
    app_flat_21: 0,
    char_22: 'burnice',
    app_rate_22: 0.63,
    avg_round_22: 9352,
    app_flat_22: 0,
    char_23: 'piper',
    app_rate_23: 0.32,
    avg_round_23: 12414,
    app_flat_23: 0,
    char_24: 'pulchra',
    app_rate_24: 0.32,
    avg_round_24: 9306,
    app_flat_24: 0,
    char_25: 'grace-howard',
    app_rate_25: 0.32,
    avg_round_25: 13737,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'grace-howard',
    app: 3.55,
    char_1: 'rina',
    app_rate_1: 40.38,
    avg_round_1: 19456,
    app_flat_1: 0,
    char_2: 'miyabi',
    app_rate_2: 37.98,
    avg_round_2: 21584,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 18.75,
    avg_round_3: 27684,
    app_flat_3: 0,
    char_4: 'harumasa',
    app_rate_4: 16.35,
    avg_round_4: 17652,
    app_flat_4: 0,
    char_5: 'vivian',
    app_rate_5: 12.02,
    avg_round_5: 24904,
    app_flat_5: 0,
    char_6: 'trigger',
    app_rate_6: 10.58,
    avg_round_6: 16008,
    app_flat_6: 0,
    char_7: 'burnice',
    app_rate_7: 10.1,
    avg_round_7: 18034,
    app_flat_7: 0,
    char_8: 'jane-doe',
    app_rate_8: 8.17,
    avg_round_8: 16725,
    app_flat_8: 0,
    char_9: 'soukaku',
    app_rate_9: 6.73,
    avg_round_9: 21586,
    app_flat_9: 0,
    char_10: 'yanagi',
    app_rate_10: 5.77,
    avg_round_10: 17152,
    app_flat_10: 0,
    char_11: 'lucy',
    app_rate_11: 5.77,
    avg_round_11: 18140,
    app_flat_11: 0,
    char_12: 'caesar',
    app_rate_12: 4.81,
    avg_round_12: 14898,
    app_flat_12: 0,
    char_13: 'seth',
    app_rate_13: 4.33,
    avg_round_13: 11927,
    app_flat_13: 0,
    char_14: 'nicole-demara',
    app_rate_14: 4.33,
    avg_round_14: 18611,
    app_flat_14: 0,
    char_15: 'piper',
    app_rate_15: 3.37,
    avg_round_15: 16145,
    app_flat_15: 0,
    char_16: 'qingyi',
    app_rate_16: 2.4,
    avg_round_16: 17358,
    app_flat_16: 0,
    char_17: 'koleda',
    app_rate_17: 2.4,
    avg_round_17: 22910,
    app_flat_17: 0,
    char_18: 'anby-demara-soldier-0',
    app_rate_18: 1.92,
    avg_round_18: 11383,
    app_flat_18: 0,
    char_19: 'anton',
    app_rate_19: 1.92,
    avg_round_19: 29006,
    app_flat_19: 0,
    char_20: 'pulchra',
    app_rate_20: 0.96,
    avg_round_20: 14122,
    app_flat_20: 0,
    char_21: 'soldier-11',
    app_rate_21: 0.96,
    avg_round_21: 7549,
    app_flat_21: 0,
    char_22: 'lycaon',
    app_rate_22: 0.48,
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'zhu-yuan',
    app_rate_23: 0.48,
    avg_round_23: 14362,
    app_flat_23: 0,
    char_24: 'evelyn',
    app_rate_24: 0.48,
    avg_round_24: 13418,
    app_flat_24: 0,
    char_25: 'anby-demara',
    app_rate_25: 0.48,
    avg_round_25: 13737,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'soldier-11',
    app: 2.94,
    char_1: 'lucy',
    app_rate_1: 47.09,
    avg_round_1: 17564,
    app_flat_1: 0,
    char_2: 'lighter',
    app_rate_2: 34.3,
    avg_round_2: 26207,
    app_flat_2: 0,
    char_3: 'astra-yao',
    app_rate_3: 30.81,
    avg_round_3: 24593,
    app_flat_3: 0,
    char_4: 'trigger',
    app_rate_4: 18.02,
    avg_round_4: 21628,
    app_flat_4: 0,
    char_5: 'caesar',
    app_rate_5: 16.28,
    avg_round_5: 25994,
    app_flat_5: 0,
    char_6: 'koleda',
    app_rate_6: 15.7,
    avg_round_6: 19410,
    app_flat_6: 0,
    char_7: 'burnice',
    app_rate_7: 11.63,
    avg_round_7: 19462,
    app_flat_7: 0,
    char_8: 'nicole-demara',
    app_rate_8: 6.4,
    avg_round_8: 18845,
    app_flat_8: 0,
    char_9: 'qingyi',
    app_rate_9: 2.33,
    avg_round_9: 16536,
    app_flat_9: 0,
    char_10: 'anby-demara',
    app_rate_10: 2.33,
    avg_round_10: 10570,
    app_flat_10: 0,
    char_11: 'pulchra',
    app_rate_11: 2.33,
    avg_round_11: 16526,
    app_flat_11: 0,
    char_12: 'anby-demara-soldier-0',
    app_rate_12: 2.33,
    avg_round_12: 15712,
    app_flat_12: 0,
    char_13: 'ben',
    app_rate_13: 1.74,
    avg_round_13: 14873,
    app_flat_13: 0,
    char_14: 'evelyn',
    app_rate_14: 1.74,
    avg_round_14: 20138,
    app_flat_14: 0,
    char_15: 'lycaon',
    app_rate_15: 1.16,
    avg_round_15: 39574,
    app_flat_15: 0,
    char_16: 'jane-doe',
    app_rate_16: 1.16,
    avg_round_16: 10302,
    app_flat_16: 0,
    char_17: 'rina',
    app_rate_17: 1.16,
    avg_round_17: 7290,
    app_flat_17: 0,
    char_18: 'grace-howard',
    app_rate_18: 1.16,
    avg_round_18: 7549,
    app_flat_18: 0,
    char_19: 'miyabi',
    app_rate_19: 1.16,
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'billy-kid',
    app_rate_20: 1.16,
    avg_round_20: 10402,
    app_flat_20: 0,
    char_21: 'piper',
    app_rate_21: 0.58,
    avg_round_21: 12154,
    app_flat_21: 0,
    char_22: 'soukaku',
    app_rate_22: 0.58,
    avg_round_22: 12237,
    app_flat_22: 0,
    char_23: 'yanagi',
    app_rate_23: 0.58,
    avg_round_23: 18334,
    app_flat_23: 0,
    char_24: 'vivian',
    app_rate_24: 0.58,
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'nekomata',
    app: 1.15,
    char_1: 'nicole-demara',
    app_rate_1: 64.18,
    avg_round_1: 23660,
    app_flat_1: 0,
    char_2: 'astra-yao',
    app_rate_2: 43.28,
    avg_round_2: 26422,
    app_flat_2: 0,
    char_3: 'trigger',
    app_rate_3: 16.42,
    avg_round_3: 23593,
    app_flat_3: 0,
    char_4: 'qingyi',
    app_rate_4: 16.42,
    avg_round_4: 24302,
    app_flat_4: 0,
    char_5: 'pulchra',
    app_rate_5: 8.96,
    avg_round_5: 21969,
    app_flat_5: 0,
    char_6: 'caesar',
    app_rate_6: 7.46,
    avg_round_6: 22372,
    app_flat_6: 0,
    char_7: 'lucy',
    app_rate_7: 7.46,
    avg_round_7: 19884,
    app_flat_7: 0,
    char_8: 'anby-demara',
    app_rate_8: 5.97,
    avg_round_8: 20285,
    app_flat_8: 0,
    char_9: 'evelyn',
    app_rate_9: 4.48,
    avg_round_9: 13012,
    app_flat_9: 0,
    char_10: 'burnice',
    app_rate_10: 4.48,
    avg_round_10: 21222,
    app_flat_10: 0,
    char_11: 'jane-doe',
    app_rate_11: 4.48,
    avg_round_11: 10158,
    app_flat_11: 0,
    char_12: 'vivian',
    app_rate_12: 2.99,
    avg_round_12: 16936,
    app_flat_12: 0,
    char_13: 'rina',
    app_rate_13: 2.99,
    avg_round_13: 17489,
    app_flat_13: 0,
    char_14: 'miyabi',
    app_rate_14: 2.99,
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'koleda',
    app_rate_15: 1.49,
    avg_round_15: 13429,
    app_flat_15: 0,
    char_16: 'piper',
    app_rate_16: 1.49,
    avg_round_16: 16661,
    app_flat_16: 0,
    char_17: 'zhu-yuan',
    app_rate_17: 1.49,
    avg_round_17: 8383,
    app_flat_17: 0,
    char_18: 'anby-demara-soldier-0',
    app_rate_18: 1.49,
    avg_round_18: 9205,
    app_flat_18: 0,
    char_19: 'lighter',
    app_rate_19: 1.49,
    avg_round_19: 14064,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: 0.0,
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: 0.0,
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: 0.0,
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'corin',
    app: 0.75,
    char_1: 'qingyi',
    app_rate_1: 29.55,
    avg_round_1: 23352,
    app_flat_1: 0,
    char_2: 'rina',
    app_rate_2: 29.55,
    avg_round_2: 25734,
    app_flat_2: 0,
    char_3: 'caesar',
    app_rate_3: 27.27,
    avg_round_3: 27903,
    app_flat_3: 0,
    char_4: 'nicole-demara',
    app_rate_4: 22.73,
    avg_round_4: 26580,
    app_flat_4: 0,
    char_5: 'trigger',
    app_rate_5: 20.45,
    avg_round_5: 22870,
    app_flat_5: 0,
    char_6: 'astra-yao',
    app_rate_6: 15.91,
    avg_round_6: 30224,
    app_flat_6: 0,
    char_7: 'lucy',
    app_rate_7: 13.64,
    avg_round_7: 21539,
    app_flat_7: 0,
    char_8: 'lycaon',
    app_rate_8: 11.36,
    avg_round_8: 16520,
    app_flat_8: 0,
    char_9: 'piper',
    app_rate_9: 9.09,
    avg_round_9: 17349,
    app_flat_9: 0,
    char_10: 'anby-demara',
    app_rate_10: 4.55,
    avg_round_10: 16907,
    app_flat_10: 0,
    char_11: 'pulchra',
    app_rate_11: 4.55,
    avg_round_11: 12838,
    app_flat_11: 0,
    char_12: 'soukaku',
    app_rate_12: 4.55,
    avg_round_12: 40261,
    app_flat_12: 0,
    char_13: 'lighter',
    app_rate_13: 2.27,
    avg_round_13: 10990,
    app_flat_13: 0,
    char_14: 'harumasa',
    app_rate_14: 2.27,
    avg_round_14: 20526,
    app_flat_14: 0,
    char_15: 'burnice',
    app_rate_15: 2.27,
    avg_round_15: 20394,
    app_flat_15: 0,
    char_16: 'ellen',
    app_rate_16: 2.27,
    avg_round_16: 60000,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: 0.0,
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: 0.0,
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: 0.0,
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: 0.0,
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: 0.0,
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: 0.0,
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'anton',
    app: 0.51,
    char_1: 'astra-yao',
    app_rate_1: 43.33,
    avg_round_1: 26906,
    app_flat_1: 0,
    char_2: 'nicole-demara',
    app_rate_2: 40.0,
    avg_round_2: 27898,
    app_flat_2: 0,
    char_3: 'qingyi',
    app_rate_3: 26.67,
    avg_round_3: 23706,
    app_flat_3: 0,
    char_4: 'rina',
    app_rate_4: 26.67,
    avg_round_4: 16091,
    app_flat_4: 0,
    char_5: 'trigger',
    app_rate_5: 16.67,
    avg_round_5: 20327,
    app_flat_5: 0,
    char_6: 'grace-howard',
    app_rate_6: 13.33,
    avg_round_6: 29006,
    app_flat_6: 0,
    char_7: 'anby-demara',
    app_rate_7: 13.33,
    avg_round_7: 18806,
    app_flat_7: 0,
    char_8: 'caesar',
    app_rate_8: 6.67,
    avg_round_8: 16161,
    app_flat_8: 0,
    char_9: 'seth',
    app_rate_9: 6.67,
    avg_round_9: 40016,
    app_flat_9: 0,
    char_10: 'lucy',
    app_rate_10: 6.67,
    avg_round_10: 21104,
    app_flat_10: 0,
    char_11: 'harumasa',
    app_rate_11: 6.67,
    avg_round_11: 39805,
    app_flat_11: 0,
    char_12: 'ben',
    app_rate_12: 3.33,
    avg_round_12: 21104,
    app_flat_12: 0,
    char_13: 'koleda',
    app_rate_13: 3.33,
    avg_round_13: 61600,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: 0.0,
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: 0.0,
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: 0.0,
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: 0.0,
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: 0.0,
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: 0.0,
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: 0.0,
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: 0.0,
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: 0.0,
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'billy-kid',
    app: 0.48,
    char_1: 'nicole-demara',
    app_rate_1: 50.0,
    avg_round_1: 25395,
    app_flat_1: 0,
    char_2: 'caesar',
    app_rate_2: 35.71,
    avg_round_2: 22498,
    app_flat_2: 0,
    char_3: 'trigger',
    app_rate_3: 25.0,
    avg_round_3: 23054,
    app_flat_3: 0,
    char_4: 'astra-yao',
    app_rate_4: 21.43,
    avg_round_4: 30590,
    app_flat_4: 0,
    char_5: 'pulchra',
    app_rate_5: 17.86,
    avg_round_5: 22668,
    app_flat_5: 0,
    char_6: 'lucy',
    app_rate_6: 10.71,
    avg_round_6: 18586,
    app_flat_6: 0,
    char_7: 'lycaon',
    app_rate_7: 7.14,
    avg_round_7: 12432,
    app_flat_7: 0,
    char_8: 'soldier-11',
    app_rate_8: 7.14,
    avg_round_8: 10402,
    app_flat_8: 0,
    char_9: 'jane-doe',
    app_rate_9: 7.14,
    avg_round_9: 11803,
    app_flat_9: 0,
    char_10: 'piper',
    app_rate_10: 7.14,
    avg_round_10: 14659,
    app_flat_10: 0,
    char_11: 'lighter',
    app_rate_11: 3.57,
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'qingyi',
    app_rate_12: 3.57,
    avg_round_12: 31046,
    app_flat_12: 0,
    char_13: 'koleda',
    app_rate_13: 3.57,
    avg_round_13: 7688,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: 0.0,
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: 0.0,
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: 0.0,
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: 0.0,
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: 0.0,
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: 0.0,
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: 0.0,
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: 0.0,
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: 0.0,
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'ben',
    app: 0.34,
    char_1: 'lighter',
    app_rate_1: 55.0,
    avg_round_1: 22805,
    app_flat_1: 0,
    char_2: 'lucy',
    app_rate_2: 55.0,
    avg_round_2: 22200,
    app_flat_2: 0,
    char_3: 'evelyn',
    app_rate_3: 20.0,
    avg_round_3: 20429,
    app_flat_3: 0,
    char_4: 'soldier-11',
    app_rate_4: 15.0,
    avg_round_4: 14873,
    app_flat_4: 0,
    char_5: 'koleda',
    app_rate_5: 15.0,
    avg_round_5: 14376,
    app_flat_5: 0,
    char_6: 'burnice',
    app_rate_6: 15.0,
    avg_round_6: 15606,
    app_flat_6: 0,
    char_7: 'astra-yao',
    app_rate_7: 15.0,
    avg_round_7: 20429,
    app_flat_7: 0,
    char_8: 'anton',
    app_rate_8: 5.0,
    avg_round_8: 21104,
    app_flat_8: 0,
    char_9: 'jane-doe',
    app_rate_9: 5.0,
    avg_round_9: 14805,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: 0.0,
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: 0.0,
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: 0.0,
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: 0.0,
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: 0.0,
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: 0.0,
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: 0.0,
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: 0.0,
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: 0.0,
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: 0.0,
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: 0.0,
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: 0.0,
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: 0.0,
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: 0.0,
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: 0.0,
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: 0.0,
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: 0.0,
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: 0.0,
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: 0.0,
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: 0.0,
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: 0.0,
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
